module.exports = __webpack_public_path__ + "img/退货.5fbe9af2.svg";